import type { HTMLAttributes } from 'react';
import type { FlexBoxProps } from './FlexBox';

export const filterHTMLAttributesInFlexBoxProps = (props: FlexBoxProps) => {
  const flexBoxPropsList: (keyof FlexBoxProps)[] = ['as', 'direction', 'content', 'aligns', 'isFullWidth', 'children', 'wrap'];

  const htmlAttributesObj = {} as HTMLAttributes<HTMLElement>;
  Object.entries(props).forEach(([key, value]) => {
    if (flexBoxPropsList.includes(key as keyof FlexBoxProps)) return;
    Object.assign(htmlAttributesObj, { [key]: value });
  });
  return htmlAttributesObj;
};
